"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.conflictStrategySchema = exports.overrideChangeTypeSchema = exports.plannedSlotStatusSchema = exports.slotSourceSchema = exports.slotTypeScopeSchema = exports.templateWeekSchema = exports.contractTypeSchema = exports.ContractTypeEnum = void 0;
const zod_1 = require("zod");
exports.ContractTypeEnum = { CDI: 'CDI', CDD: 'CDD' };
exports.contractTypeSchema = zod_1.z.enum(['CDI', 'CDD']);
exports.templateWeekSchema = zod_1.z.enum(['A', 'B']);
exports.slotTypeScopeSchema = zod_1.z.enum(['global', 'office']);
exports.slotSourceSchema = zod_1.z.enum(['GENERATED', 'OVERRIDE', 'MANUAL']);
exports.plannedSlotStatusSchema = zod_1.z.enum([
    'PLANNED',
    'CANCELLED',
    'ON_PAID_LEAVE',
    'ON_SICK',
    'ON_EXCEPTIONAL',
    'ON_PUBLIC_HOLIDAY',
    'ON_MATERNITY_LEAVE',
    'ON_BIRTH_LEAVE',
    'ON_UNPAID_LEAVE',
]);
exports.overrideChangeTypeSchema = zod_1.z.enum([
    'MOVED',
    'REASSIGNED',
    'CANCELLED',
    'ABSENCE',
]);
exports.conflictStrategySchema = zod_1.z.enum([
    'skip',
    'overwrite-generated',
    'block',
]);
